import { render, staticRenderFns } from "./ApproveDialog.vue?vue&type=template&id=2760d11d&scoped=true&"
import script from "./ApproveDialog.vue?vue&type=script&lang=js&"
export * from "./ApproveDialog.vue?vue&type=script&lang=js&"
import style0 from "./ApproveDialog.vue?vue&type=style&index=0&id=2760d11d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2760d11d",
  null
  
)

export default component.exports